import { injectable } from "inversify";
import { type IService, Logger } from "@designboticteam/core";
import { createStore } from "./store";

@injectable()
class Kolega3DStoreService implements IService {
	public readonly serviceName = "Kolega3DStoreService";
	private readonly logger = new Logger(`🧪 ${this.serviceName}`, {
		color: "#ffffff",
		backgroundColor: "#00ff00",
	});

	public readonly store = createStore();

	constructor() {
		this.logger.log("constructed");
	}

	public initialize(): void {
		this.logger.log("initialized");
	}

	public dispose(): void {
		this.store.setState(this.store.getInitialState());
		this.logger.log("disposed");
	}
}

export { Kolega3DStoreService };
